import { render, staticRenderFns } from "./SublimesQuotator.vue?vue&type=template&id=00b047b9&scoped=true&"
import script from "./SublimesQuotator.vue?vue&type=script&lang=js&"
export * from "./SublimesQuotator.vue?vue&type=script&lang=js&"
import style0 from "./SublimesQuotator.vue?vue&type=style&index=0&id=00b047b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b047b9",
  null
  
)

export default component.exports